import { StorageService as n } from "@nextgen-web-framework/core";
function l({ htmlString: t, dynamicData: e }) {
  let o = "";
  return t && (o = t.replace(
    /\{(\w+)\}/g,
    (i, r) => e[r] !== void 0 ? e[r] : i
  )), o;
}
const m = () => {
  const t = n.getSessionStorage();
  t == null || t.remove("sop-list-tab"), t == null || t.remove("sop-downline-user");
};
export {
  l as getHtmlStringWithDynamicData,
  m as mySopPrevNavignationCleanup
};
//# sourceMappingURL=commonUtils.js.map
